export enum ListingCardLocations {
  myFavorites = 'myFavorites',
  search = 'search',
  searchLanding = 'searchLanding',
  homeRecentlyViewedListings = 'homeRecentlyViewedListings',
  home = 'home',
  map = 'map',
  ldp = 'LDP',
  ldpRecentlyViewedListings = 'ldpRecentlyViewedListings',
  ldpSimilarListings = 'ldpSimilarListings',
  talkSimilarListings = 'talkSimilarListings',
  unspecified = 'unspecified',
  contactAdvertiser = 'contactAdvertiser',
  advertiserProfile = 'advertiserProfile',
  ldpUnitTypes = 'ldpUnitTypes',
}
